export const getSearchString = (isAccessStorage?: boolean) => {
  const storage = window.sessionStorage;
  const searchFromLS = storage.getItem('dateRange');

  const params = window.location.search;
  if (params && !isAccessStorage)
    return new URLSearchParams(window.location.search);
  if (searchFromLS) return new URLSearchParams(searchFromLS);
  return new URLSearchParams();
};
